<img style="width:100%;height:auto" [src]="imageSrc" />

<ngx-dropzone-remove-badge *ngIf="removable" (click)="_remove($event)">